export const englishValidationMessage = {
    /**
     * Gives the validation message for the required fields
     * @param {string} fieldName
     */
    forRequiredField(fieldName) {
        // Transforming the entire message to the upper case as per the UX, can be changed later
        return `${fieldName} cannot be empty`.toUpperCase()
    },

    forAlphabeticOnly() {
        return "alphabetic only".toUpperCase()
    },

    forAlphanumericOnly() {
        return "alphanumeric only".toUpperCase()
    },

    forAlphanumericAndSpacesOnly() {
        return "alphanumeric and spaces only".toUpperCase()
    },

    forPositiveNumber(fieldName) {
        return `${fieldName} must be greater than 0`.toUpperCase()
    },

    forMaxDecimalPlaces(fieldName, places) {
        return `${fieldName} can have up to ${places} decimal places`.toUpperCase()
    },

    forNumericOnly() {
        return "numeric values only".toUpperCase()
    },

    forDuplicateField(fieldName) {
        return `${fieldName} already exists`.toUpperCase()
    },

    forEmailAddress() {
        return `enter valid email address`.toUpperCase()
    },

    forInvalidFormat(fieldName, type, format) {
        return `Invalid ${fieldName}${
            format ? `. Expected ${type} format ${format}` : ""
        }`.toUpperCase()
    },

    forStartDateBeforeEndDate() {
        return "Start date must be before or equal to end date".toUpperCase()
    },

    forDatesInFuture() {
        return "Dates must be today or in the future".toUpperCase()
    },

    forConfirmingCancel(
        selectedAction,
        selectedCars,
        failedCars,
        shipmentData
    ) {
        return `You are about to cancel ${selectedAction} ${"("}${
            failedCars.length ? failedCars.length : selectedCars.length
        }${")"}${
            shipmentData.length
        } Equipment. Do you want to confirm the operation?`
    },

    forConfirmingAction(
        selectedAction,
        selectedCars,
        failedCars,
        shipmentData
    ) {
        return `You are about to ${selectedAction} ${"("}${
            failedCars.length ? failedCars.length : selectedCars.length
        }${")"}${
            shipmentData.length
        } Equipment. Do you want to confirm the operation?`
    },

    forUnableToProcessAction(selectedAction, selectedCars, temparray) {
        return `${selectedAction} request for ${temparray.length} out of ${selectedCars.length} Equipment was unable to be process, please see action results.`
    },

    forPlacedAction(selectedAction, selectedCars) {
        return ` ${selectedAction} request for ${selectedCars.length} Equipment has been Placed.`
    },

    forActionInProcess() {
        return `Please wait while your request is processed.`
    },

    forPlanDeleted(deletePlanName) {
        return `Plan "${deletePlanName}" has been deleted.`
    },

    forSelectingCarSpecifics(selectedCar) {
        return `Select ${selectedCar} car specifics`
    },

    invalidNumber: "This is invalid Number",
    invalidCharacter: "This is invalid Character",
    unableToProcess: "Unable to Process Request.",
}
